// Bridges React Router's hook-only navigate() into plain, non-component code
// (e.g. mainNavigationConfig.tsx's static button/address handlers). We use
// <BrowserRouter>, not a data router, so there's no router.navigate() escape
// hatch - NavigationGuardProvider (mounted once near the app root) syncs its
// guardedNavigate into this ref, and navigateTo() below is what plain config
// closures call instead of needing to be hooks themselves.
type NavigateFn = (path: string) => void;

let currentNavigate: NavigateFn | null = null;

export const setGlobalNavigate = (navigate: NavigateFn) => {
  currentNavigate = navigate;
};

export const navigateTo = (path: string) => {
  if (!currentNavigate) {
    console.warn(`navigateTo('${path}') called before the router mounted`);
    return;
  }
  currentNavigate(path);
};
